/* global Word */

import { applyDraftStyle } from "@/lib/styleService";
import { formatSection } from "./wordFormatting";
import Logger from "@/utility/logger";

// Creates a table in the Word document at the specified target word with the provided data
export const createTable = async (targetWord: string, data, setGeneratedSections, section, draftStyles) => {
  await Word.run(async (context) => {
    const startBookmark = context.document.getBookmarkRangeOrNullObject(targetWord + "_START");
    const endBookmark = context.document.getBookmarkRangeOrNullObject(targetWord + "_END");

    startBookmark.load("isNullObject, end");
    endBookmark.load("isNullObject");
    await context.sync();

    if (startBookmark.isNullObject || endBookmark.isNullObject) {
      Logger.warn("One or both bookmarks were not found:", targetWord);
      return;
    }

    const paragraph = startBookmark.insertParagraph("", Word.InsertLocation.after);
    await context.sync();

    let insertionPoint: Word.Range = paragraph.getRange(Word.RangeLocation.end);

    const combinedRange = insertionPoint.expandTo(endBookmark);

    const wordTable = combinedRange.insertTable(data.length, data[0].length, Word.InsertLocation.after, data);

    // Apply default font to the whole table range to ensure consistent styling
    const tableRange = wordTable.getRange();
    await applyDraftStyle(tableRange);

    const wordRows = wordTable.rows;
    wordRows.load("items");

    await context.sync();

    for (var i = 0; i < wordRows.items.length; i++) {
      const curRow = wordRows.items[i];

      const cells = curRow.cells;
      cells.load("items");
      await context.sync();

      for (let cell of cells.items) {
        const cellBody = cell.body;
        const range = cellBody.getRange();
        range.styleBuiltIn = Word.BuiltInStyleName.normal;
      }

      if (i == 0) {
        const headerRow = curRow;
        headerRow.shadingColor = "lightGray";
        headerRow.preferredHeight = 35;
        headerRow.font.name = draftStyles.fontFamily;
        headerRow.font.color = draftStyles.fontColor;
        headerRow.font.size = draftStyles.fontSize + 3;
        headerRow.font.bold = true;
        headerRow.horizontalAlignment = "Centered";
        headerRow.verticalAlignment = "Center";
        // Ensure character-level bold in each header cell so it isn't overridden
        const headerCells = headerRow.cells;
        headerCells.load("items");
        await context.sync();
        for (let hCell of headerCells.items) {
          const hRange = hCell.body.getRange();
          hRange.font.bold = true;
        }
      } else {
        curRow.preferredHeight = 15;
        curRow.font.color = draftStyles.fontColor;
        curRow.font.name = draftStyles.fontFamily;
        curRow.font.size = draftStyles.fontSize;
        curRow.font.bold = false;
        curRow.verticalAlignment = "Center";
        curRow.horizontalAlignment = "Centered";
      }
    }

    await context.sync();

    const searchResults = combinedRange.search("Jenly.AI generated content will be inserted here.", {
      matchCase: false,
      matchWholeWord: true,
      ignorePunct: true,
    });

    searchResults.load("items");
    await context.sync();

    if (searchResults.items.length > 0) {
      Logger.debug("Found placeholder phrase after bookmark.");
      searchResults.items[0].insertText(" ", Word.InsertLocation.replace);
      await context.sync();
    }
  });
  setGeneratedSections((prev) => [...prev, section]);
  formatSection(targetWord);
};
